import { useState, useEffect } from 'react';
import { preloadImage, asyncTimeout } from '@utils/common';
import { isImageCached } from '@utils/react';

function useIntroductionReady(introduction) {
  const [isReady, setReady] = useState(introduction.every(it => it.type !== "Image" || isImageCached({
    src: it.src,
    sizes: "700px"
  })));
  useEffect(() => {
    if (isReady) {
      return;
    }
    const unreadyImages = introduction.filter(it => it.type === "Image" && !isImageCached({
      src: it.src,
      sizes: "700px"
    }));
    Promise.all(unreadyImages.map(img => Promise.race([preloadImage(img.src), asyncTimeout(3000)]))).then(() => setReady(true));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [introduction]);
  return isReady;
}

export { useIntroductionReady };
//# sourceMappingURL=hook.introduction-ready.js.map
